export default [
  {
    label: 'None or None of the above', value: 'None or None of the above',
  },
  {
    label: 'Health Care Business (as defined in 11 U.S.C. § 101(27A))', value: 'Health Care Business (as defined in 11 U.S.C. § 101(27A))',
  },
  {
    label: 'Single Asset Real Estate (as defined in 11 U.S.C. § 101(51B))', value: 'Single Asset Real Estate (as defined in 11 U.S.C. § 101(51B))',
  },
  {
    label: 'Railroad (as defined in 11 U.S.C. § 101(44))', value: 'Railroad (as defined in 11 U.S.C. § 101(44))',
  },
  {
    label: 'Stockbroker (as defined in 11 U.S.C. § 101(53A))', value: 'Stockbroker (as defined in 11 U.S.C. § 101(53A))',
  },
  {
    label: 'Commodity Broker (as defined in 11 U.S.C. § 101(6))', value: 'Commodity Broker (as defined in 11 U.S.C. § 101(6))',
  },
  {
    label: 'Clearing Bank (as defined in 11 U.S.C § 781(3))', value: 'Clearing Bank (as defined in 11 U.S.C § 781(3))',
  },
];



// WEBPACK FOOTER //
// ./src/data/debtorBusiness.js